import '../types';
import {Component} from "react";

export default class FilterCheckbox extends Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  state = {
    checked: false
  }

  handleCheckboxChange = (e: any) => {
    let value = e.target.value;
    let checked = e.target.checked;
    if (checked) {
      window.addBrandFilter(value);
    } else {
      window.removeBrandFilter(value);
    }
    this.setState({checked: e.target.checked});
  }

  render() {
    return(
      <div className={'filter-checkbox'}>
        <input data-checked={this.state.checked} type={'checkbox'} id={`${this.props.name}-${this.props.dataKey}`} name={this.props.name} value={this.props.value} onChange={(e) => this.handleCheckboxChange(e)} />
        <label htmlFor={`${this.props.name}-${this.props.dataKey}`}>{this.props.value}</label>
      </div>
    )
  }
}
